import { SignIn, SignUp, useAuth } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router-dom";
import { routes } from "schemas/routes";

import Loading from "components/Loading";
import { LANDING_PAGE_LINK } from "constants/influencer";

import InfluencerLayout from "./Layout/Influencer";
import { AuthAction } from "./schema";

interface AuthPageProps {
  action: AuthAction;
  prevLink: string;
}

const AuthPage = ({ action, prevLink }: AuthPageProps) => {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  const getSignInRedirectUrl = () => {
    if (
      prevLink &&
      !prevLink.startsWith(`/${routes.signIn}`) &&
      !prevLink.startsWith(`/${routes.signUp}`) &&
      (prevLink.includes(routes.dashboard) ||
        prevLink.includes(routes.onboardingInfluencer))
    ) {
      return prevLink;
    }
    return `/${routes.home}${location.search}`;
  };

  const signInRedirectUrl = getSignInRedirectUrl();
  const signUpRedirectUrl = `/${routes.onboardingInfluencer}${location.search}`;
  const emailMatch = location.search?.match(/email=([^&]*)/);
  const email = emailMatch ? decodeURIComponent(emailMatch[1]) : "";

  if (window.location.hostname === "crm.hatchways.io") {
    const newPath = "https://app.onbento.com" + window.location.pathname;
    window.location.href = newPath;
    return null;
  }

  if (isSignedIn) {
    return <Navigate to={signInRedirectUrl} replace />;
  }

  const appearance = {
    layout: {
      logoLinkUrl: LANDING_PAGE_LINK,
      privacyPageUrl: "https://www.onbento.com/privacy-policy",
    },
    elements: {
      card: {
        width: { xs: "auto", md: "100%" },
        boxShadow: "none",
      },
    },
  };
  if (isLoaded) {
    return (
      <InfluencerLayout>
        {action === AuthAction.SIGN_UP && (
          <SignUp
            initialValues={{
              emailAddress: email || "",
            }}
            signInUrl={`/${routes.signIn}`}
            afterSignUpUrl={signUpRedirectUrl}
            afterSignInUrl={signInRedirectUrl}
            appearance={appearance}
          />
        )}
        {action === AuthAction.SIGN_IN && (
          <SignIn
            initialValues={{
              emailAddress: email || "",
            }}
            signUpUrl={`/${routes.signUp}`}
            afterSignUpUrl={signUpRedirectUrl}
            afterSignInUrl={signInRedirectUrl}
            appearance={appearance}
          />
        )}
      </InfluencerLayout>
    );
  } else {
    return <Loading />;
  }
};

export default AuthPage;
